import { render, staticRenderFns } from "./ConventionMenuItem.vue?vue&type=template&id=4781040e&scoped=true"
import script from "./ConventionMenuItem.vue?vue&type=script&lang=js"
export * from "./ConventionMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ConventionMenuItem.vue?vue&type=style&index=0&id=4781040e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781040e",
  null
  
)

export default component.exports